import { styled } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { createTransition, dontForwardProps } from '../../../util';
const textAreaShadowLabel = ({
  isFocus,
  isHover,
  disabled,
  hasContent
}) => {
  let shadowColor = colors.neutralDeeper;
  if ((isFocus || isHover || hasContent && isFocus) && !disabled) {
    shadowColor = colors.black;
  }
  return shadowColor;
};
export const TextareaLabel = styled.label.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1n52o1e-0"
})(["position:relative;pointer-events:none;display:block;top:0;left:0;right:0;font-size:", ";-moz-osx-font-smoothing:grayscale;font-weight:", ";line-height:1.25rem;padding-bottom:0;padding-left:0.75rem;padding-top:0.75rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0;border-radius:0.375rem 0.375rem 0 0;color:", ";", " ", ""], getFontSize(2), getFontWeight('base'), textAreaShadowLabel, ({
  isFocus,
  hasContent
}) => (isFocus || hasContent) && `font-size: ${getFontSize(1)};`, createTransition({
  properties: ['font-size', 'color']
}));